import { APP_INITIALIZER } from '@angular/core';

import { CompanyService } from '../services/company.service';
import { CookiePermissionService } from '../services/cookie-permission.service';
import { IndexedDBService } from '../services/indexed-db-storage.service';
import { StorageService } from '../services/storage.service';
import { AuthenticationService } from '~/core/services/authentication.service';

export function initializeStorageApp(
  cookieService: CookiePermissionService,
  auth: AuthenticationService,
  companyService: CompanyService,
): () => Promise<void> {
  return async () => {
    try {
      await IndexedDBService.openDB();
      await Promise.all([StorageService.initializeCacheFromDB(), companyService.initializeCache()]);
      await auth.init();
      cookieService.init();
    } catch (error) {
      console.error('Erro na inicialização do initializeStorageApp:', error);
    }
  };
}

export const provideInitializeStorageApp = () => {
  return {
    provide: APP_INITIALIZER,
    useFactory: initializeStorageApp,
    deps: [CookiePermissionService, AuthenticationService, CompanyService],
    multi: true,
  };
};
